<!--
 * @Descripttion: 趋势标记
 * @version: 1.0
 * @Author: sakuya
 * @Date: 2021年11月11日11:07:10
 * @LastEditors:
 * @LastEditTime:
-->

<template>
	<span class="mn-trend" :class="'mn-trend--'+type">
		<el-icon v-if="iconType=='P'" class="mn-trend-icon"><el-icon-top /></el-icon>
		<el-icon v-if="iconType=='N'" class="mn-trend-icon"><el-icon-bottom /></el-icon>
		<el-icon v-if="iconType=='Z'" class="mn-trend-icon"><el-icon-right /></el-icon>
		<em class="mn-trend-prefix">{{prefix}}</em>
		<em class="mn-trend-value">{{modelValue}}</em>
		<em class="mn-trend-suffix">{{suffix}}</em>
	</span>
</template>

<script>
	export default {
		props: {
			modelValue: { type: Number, default: 0 },
			prefix: { type: String, default: "" },
			suffix: { type: String, default: "" },
			reverse: { type: Boolean, default: false }
		},
		computed: {
			absValue(){
				return Math.abs(this.modelValue);
			},
			iconType(v){
				if(this.modelValue == 0){
					v = 'Z'
				}else if(this.modelValue < 0){
					v = 'N'
				}else if(this.modelValue > 0){
					v = 'P'
				}
				return v
			},
			type(v){
				if(this.modelValue == 0){
					v = 'Z'
				}else if(this.modelValue < 0){
					v =  this.reverse?'P':'N'
				}else if(this.modelValue > 0){
					v =   this.reverse?'N':'P'
				}
				return v
			}
		}
	}
</script>

<style scoped>
	.mn-trend {display: flex;align-items: center;}
	.mn-trend-icon {margin-right: 2px;}
	.mn-trend em {font-style: normal;}
	.mn-trend-prefix {margin-right: 2px;}
	.mn-trend-suffix {margin-left: 2px;}
	.mn-trend--P {color: #f56c6c;}
	.mn-trend--N {color: #67c23a;}
	.mn-trend--Z {color: #555;}
</style>
